import { testimonials } from '@/mocks/testimonials';

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      <i className="ri-star-fill text-accent-500 text-sm" />
      <i className="ri-star-fill text-accent-500 text-sm" />
      <i className="ri-star-fill text-accent-500 text-sm" />
      <i className="ri-star-fill text-accent-500 text-sm" />
      <i className="ri-star-fill text-accent-500 text-sm" />
      <span className="text-xs text-foreground-500 ml-1">({rating}/5)</span>
    </div>
  );
}

export default function Testimonials() {
  return (
    <section className="section-padding bg-background-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-12 md:mb-16">
          <div>
            <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
              ARKAMIZDAKİLER
            </p>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter">
              ONLAR NE DEDİ?
            </h2>
          </div>
          <a href="#contact" className="btn-outline text-sm font-bold uppercase tracking-wider">
            Sıradaki Sen Ol
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-5 md:gap-6 mb-12 md:mb-16">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="glass-card-hover rounded-2xl p-6 md:p-8 group"
            >
              <div className="flex items-center gap-4 mb-5">
                <div className="w-12 h-12 bg-background-200 rounded-full flex items-center justify-center shrink-0">
                  <i className="ri-user-3-line text-xl text-foreground-400" />
                </div>
                <div>
                  <h4 className="text-base font-bold text-foreground-50">
                    {t.name}
                  </h4>
                  <p className="text-xs text-foreground-500">
                    {t.role}
                  </p>
                  <p className="text-xs text-primary-500 font-semibold">{t.company}</p>
                </div>
              </div>
              <StarRating rating={t.rating} />
              <p className="text-sm text-foreground-300 leading-relaxed mt-4 italic">
                &ldquo;{t.text}&rdquo;
              </p>
            </div>
          ))}
        </div>

        {/* CTA Banner */}
        <div className="glass-card rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <div>
            <h3 className="text-xl md:text-2xl font-bold text-foreground-50 mb-2">
              Sen de Başarı Hikayeni Yaz
            </h3>
            <p className="text-sm md:text-base text-foreground-400">
              Onlar başardı, sıra sende. Dijital dönüşümüne hemen başla.
            </p>
          </div>
          <a href="#contact" className="btn-primary shrink-0">
            Hemen Başla
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}